import { useQuery } from '@apollo/client';
import type React from 'react';
import getLibraryCollection from 'src/api/collection/libraryCollection';
import { LIBRARY_COLLECTION_NAME, LIBRARY_PAGE, SYSTEM, VIEW_CONTEXT } from 'src/constants';
import { FilterPopoverProvider } from 'src/context/FilterPopoverContext';
import DrawerAndPushedContents from 'src/HomePage/DrawerAndPushedContents/DrawerAndPushedContents';
import styles from 'src/HomePage/HomePageStyles';
import TopNavBar from 'src/HomePage/TopNavBar/TopNavBar';
import { useFilterPersistence } from 'src/hooks/useFilterPersistence';
import viewStateVar from 'src/store/viewState';

// GraphQL response types
interface CollectionNode {
  id: string;
  name: string;
  collectionType: string;
}

interface CollectionEdge {
  node: CollectionNode;
}

interface LibraryCollectionData {
  allCollections: {
    edges: CollectionEdge[];
  };
}

const HomePage: React.FC = () => {
  const classes = styles();

  // Initialize filter persistence for library scope
  useFilterPersistence(VIEW_CONTEXT.LIBRARY);

  useQuery<LibraryCollectionData>(getLibraryCollection, {
    variables: {
      name: LIBRARY_COLLECTION_NAME,
      collectionType: SYSTEM,
    },
    onCompleted: (data: LibraryCollectionData) => {
      const libraryNode: CollectionNode =
        data.allCollections.edges && data.allCollections.edges.length > 0
          ? data.allCollections.edges[0].node
          : { id: '', name: '', collectionType: '' };
      viewStateVar({
        ...viewStateVar(),
        collectionId: libraryNode.id,
      });
    },
  });

  return (
    <FilterPopoverProvider>
      <div className={classes.homePage}>
        <TopNavBar currentPage={LIBRARY_PAGE} />
        <DrawerAndPushedContents />
      </div>
    </FilterPopoverProvider>
  );
};

export default HomePage;
